module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "b-gray-1 filter-wrp m-t-md m-b-20"
  }, [_vm._v("\n    " + _vm._s( /** 分类 */ ) + "\n    "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "gray-4 pull-left"
  }, [_vm._v("分类：")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content b-between"
  }, _vm._l((_vm.categories), function(c) {
    return _c('span', {
      class: {
        'filter-tag': true,
        'active': c.active
      },
      on: {
        "click": function($event) {
          return _vm.clickCategory(c)
        }
      }
    }, [_vm._v(_vm._s(c && c.name))])
  }), 0)]), _vm._v("\n    " + _vm._s( /** 类别 */ ) + "\n    "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "gray-4 pull-left"
  }, [_vm._v("类别：")]), _vm._v(" "), _c('div', {
    staticClass: "filter-content"
  }, _vm._l((_vm.types), function(c, index) {
    return _c('span', {
      class: {
        'filter-tag': true,
        'active': index === _vm.activeTypeIndex
      },
      on: {
        "click": function($event) {
          return _vm.clickCaseType(index)
        }
      }
    }, [_vm._v(_vm._s(c))])
  }), 0)])]), _vm._v("\n  " + _vm._s( /** 价格 */ ) + "\n  "), _c('div', {
    staticClass: "price-wrp"
  }, [_vm._l((_vm.orderTypes), function(o, index) {
    return [_c('span', {
      class: {
        'order-tag': true,
        'active': index === _vm.condition.order_type
      },
      on: {
        "click": function($event) {
          return _vm.clickOrderType(index)
        }
      }
    }, [_vm._v(_vm._s(o))]), _vm._v("|\n    ")]
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.price_min),
      expression: "condition.price_min"
    }],
    staticClass: "price-filter price-input m-l-md",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.condition.price_min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "price_min", $event.target.value)
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.price_max),
      expression: "condition.price_max"
    }],
    staticClass: "price-filter price-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.condition.price_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "price_max", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "price-vrf-btn price-filter",
    on: {
      "click": function($event) {
        return _vm.choosePriceRange()
      }
    }
  }, [_vm._v("确定")]), _vm._v("\n    " + _vm._s( /** price btn group */ ) + "\n    "), _vm._l((_vm.priceTags), function(p, index) {
    return _c('span', {
      staticClass: "price-filter",
      class: {
        'price-btn': true,
        'active': p.active
      },
      on: {
        "click": function($event) {
          return _vm.choosePriceTag(index)
        }
      }
    }, [_vm._v(_vm._s(p.name))])
  })], 2), _vm._v("\n  " + _vm._s( /** 地区 */ ) + "\n  "), _c('div', {
    staticClass: "b-gray-1 filter-wrp m-b-md",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPromotion),
      expression: "isPromotion"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPromotion) ? _vm._i(_vm.isPromotion, null) > -1 : (_vm.isPromotion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPromotion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPromotion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPromotion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPromotion = $$c
        }
      }
    }
  }), _vm._v(" 正在促销")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasVideo),
      expression: "hasVideo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasVideo) ? _vm._i(_vm.hasVideo, null) > -1 : (_vm.hasVideo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hasVideo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasVideo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hasVideo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasVideo = $$c
        }
      }
    }
  }), _vm._v(" 包含视频")]), _vm._v(" "), _c('div', {
    staticClass: "po-r m-l-md region-btn",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.city && _vm.city.name) + " "), _c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v("\n    " + _vm._s( /** region selector */ ) + "\n    "), _c('div', {
    staticClass: "region-selector"
  }, [_c('div', {
    staticClass: "allRegion-tag",
    on: {
      "click": function($event) {
        return _vm.chooseNonCity()
      }
    }
  }, [_vm._v("全国")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "region-title"
  }, [_vm._v("热门城市")]), _vm._v(" "), _c('div', {
    staticClass: "region-tag-wrp"
  }, _vm._l((_vm.hotCities), function(c) {
    return _c('span', {
      staticClass: "region-tag",
      on: {
        "click": function($event) {
          return _vm.chooseHotCity(c)
        }
      }
    }, [_vm._v(_vm._s(c && c.cityName))])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "region-title"
  }, [_vm._v("其他城市")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('div', {
    staticClass: "c-b c-b-primary pull-right text-center clickCityConfirm",
    on: {
      "click": function($event) {
        return _vm.clickCityConfirm()
      }
    }
  }, [_c('span', [_vm._v("确定")])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province),
      expression: "province"
    }],
    staticClass: "form-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.provinces), function(op) {
    return _c('option', {
      domProps: {
        "value": op
      }
    }, [_vm._v(_vm._s(op.name))])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-input m-l-lg",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cities), function(city, index) {
    return _c('option', {
      domProps: {
        "value": city
      }
    }, [_vm._v(_vm._s(city.name))])
  }), 0)])])])]), _vm._v("\n  " + _vm._s( /** content*/ ) + "\n  "), _c('div', {
    staticClass: "clearfix m-t-md c-3-1-wrp"
  }, _vm._l((Math.ceil(_vm.cases.length / 3)), function(s) {
    return (_vm.cases.length) ? _c('div', {
      staticClass: "c-3-1-wrp clearfix"
    }, _vm._l((_vm.sthItems(s)), function(c) {
      return _c('div', {
        staticClass: "c-3-1 m-b-md b-gray-1 hp-item-6",
        on: {
          "click": function($event) {
            return _vm.gotoCase(c.id)
          }
        }
      }, [_vm._v("\n        " + _vm._s( /** use background for image */ ) + "\n        "), _c('div', {
        staticClass: "m-a img-c-div h-44",
        style: ({
          backgroundImage: "url(" + c.coverImgUrl + ")"
        })
      }), _vm._v(" "), (c.isFavored) ? _c('div', {
        staticClass: "collect-heat text-center",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.unFavorCaseInfo(c)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-heart heart-pink"
      }), _vm._v(" "), _c('span', {
        staticClass: "gray-1 text-medium"
      }, [_vm._v(_vm._s(c.favorNum))])]) : _vm._e(), _vm._v(" "), (!c.isFavored) ? _c('div', {
        staticClass: "collect-heat text-center",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.favorCaseInfo(c)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-heart-o gray-1"
      }), _vm._v(" "), _c('span', {
        staticClass: "gray-1 text-medium"
      }, [_vm._v(_vm._s(c.favorNum))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "m-a b-gray-1 p-a h-p-item-c"
      }, [_c('div', {
        staticClass: "m-b-15 text-elli"
      }, [_c('span', {
        staticClass: "f-6"
      }, [_c('span', [_vm._v(_vm._s(c.shopInfo && c.shopInfo.cityName ? c.shopInfo && c.shopInfo.cityName : '北京'))]), _vm._v("｜" + _vm._s(c.title))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), ((c.shopInfo && c.shopInfo.name) !== null && (c.shopInfo && c.shopInfo.name) !== undefined) ? _c('span', {
        staticClass: "f-7"
      }, [_vm._v(_vm._s(c.shopInfo && c.shopInfo.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "gray-1 text-small"
      }, [_c('div', {
        staticClass: "text-elli"
      }, [_vm._v(_vm._s(c.description))])])])])
    }), 0) : _vm._e()
  }), 0), _vm._v(" "), (_vm.showHint) ? _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.hintMsg))]) : _vm._e(), _vm._v(" "), _c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "callback": _vm.loadData,
      "options": _vm.paginationOptions
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb6457a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 611
// module chunks = 1